import axios from "./AxiosInstance"

const getTypes = () => axios.get(`api/eventTypes`)
const getConsultationTypes = () => axios.get(`api/consultationTypes`)
const create = (data) => axios.post(`api/events`, { ...data })
const update = (data, id) => axios.put(`api/events/${id}`, { ...data })
const deleteById = (id) => axios.delete(`api/events/${id}`)
const createCalendar = (name) => axios.post(`api/calendars`, { name: name })
const getUsersEvents = (userId) => axios.get(`api/users/${userId}/events`)
const getCalendars = () => axios.get(`api/calendars`)
const GetUsersIndividualEvents = (userId) => axios.get(`api/events?isDE=false&userId=${userId}&paginated=false`)

export const EventService = {
    update,
    GetUsersIndividualEvents,
    getTypes,
    createCalendar,
    create,
    getConsultationTypes,
    getUsersEvents,
    deleteById,
    getCalendars
}
